import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {BaseClientComponent} from '../base-client.component';
import {environment} from '../../../environments/environment';
import * as _ from 'lodash';
import {SelectItem} from 'primeng/api';
import {Etree} from '../../models/Etree';
import {AwsService} from '../../services/aws.service';
import {AwsServiceType} from '../../Enum/aws-service-type.enum';
import {OverlayPanel} from 'primeng/overlaypanel';
import {UIChart} from 'primeng/chart';

@Component({
  selector: 'app-etrees-counters-live',
  templateUrl: './etrees-counters-live.component.html',
  styleUrls: ['./etrees-counters-live.component.scss']
})
export class EtreesCountersLiveComponent extends BaseClientComponent implements OnInit, OnDestroy {
  setIntervalHandle = null;
  defaultColors = ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#8B0707', '#329262', '#5574A6', '#3B3EAC'];
  colorIdx = 0;
  etrees: any;
  etreesByIds: any;
  listEtreesDropDown: SelectItem[] = [];
  selectedEtreeId: string;
  listCrosscoDropDown: SelectItem[] = [];
  selectedCrossco: string;
  @ViewChild('fieldsetLivePortDataAnchor') fieldsetLivePortData: ElementRef;
  etreesClientData: any;
  etreesToDisplay: any;
  etreesClientDataAsString: any;
  boundedRefreshToken = null;
  loadedEtrees = true;
  datetimeFormat = 'medium';
  selectedGraphSeries = null;
  selectedGraphKey = null;
  selectedGraphField = null;
  selectedGraphData = null;
  @ViewChild('chartValuesHistory') chartValuesHistory: UIChart;
  warningEndpointsEtreesByKeys: any;
  warningMonitoringDevicesEtreesByKeys: any;
  images: any = [];

  constructor(
    public authenticationService: AuthenticationService,
    protected utilsService: UtilsService,
    protected http: HttpClient,
    public awsService: AwsService,
  ) {
    super();
    this.boundedRefreshToken = this.awsService.refreshToken.bind(this);
    const mySub = this.awsService.counterDataUpdated$.subscribe(() => {
      this.counterDataUpdated();
    });
    this.subscriptions.push(mySub);
    this.images.push({
      source: 'assets/images/counters_large.png',
      thumbnail: 'assets/images/counters_25.png',
      title: 'Port counters / E-Trees counters explanation'
    });
  }

  public onChangeSelectedEtree() {
    this.selectedCrossco = null;
  }

  public onChangeSelectedCrossco() {
    this.selectedEtreeId = null;
  }

  onClickActivatePortalPub() {
    this.awsService.activatePortalPub(AwsServiceType.ALL);
  }

  onClickSelectEtree(etreeId) {
    if (etreeId === this.selectedEtreeId) {
      this.selectedEtreeId = null;
    } else {
      this.selectedEtreeId = etreeId;
    }
    this.selectedCrossco = null;
    this.scrollToTopLivePortsData();
  }

  onClickSelectCrossCo(crosscoId) {
    if (crosscoId === this.selectedCrossco) {
      this.selectedCrossco = null;
    } else {
      this.selectedCrossco = crosscoId;
    }
    this.selectedEtreeId = null;
    this.scrollToTopLivePortsData();
  }

  ngOnInit() {
    // this.loadingStatus = 'Waiting for server authentication...';
    this.utilsService.lockUi();
    const subscribe1$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.utilsService.unlockUi();
      this.loadEtrees();
      this.awsService.updateAwsParametersFromServer().then(() => {
        if (this.awsService.awsPortalEtreesCountersIsActivated && this.awsService.awsPortalKeys) {
          this.awsService.initAwsSubscription();
        }
      });
      this.setIntervalHandle = setInterval(() => {
        this.awsService.updateAwsParametersFromServer();
      }, 5 * 60 * 1000);
    });
    this.subscriptions.push(subscribe1$);
  }

  getNextColor() {
    this.colorIdx = (this.colorIdx + 1) % this.defaultColors.length;
    const dsColor = this.defaultColors[this.colorIdx];
    return dsColor;
  }

  public async loadEtrees() {
    const etreesUrl = environment.baseUrlWs + '/api/bw_etrees';
    this.loadedEtrees = false;
    this.utilsService.cacheableObservable(() => this.http.get<any>(etreesUrl),
      'etrees_aws_' + this.authenticationService.userAuthenticated.uniqid, false)
      .subscribe({
          next: (response) => {
            this.etrees = response;
            this.etreesByIds = {};
            // this.etreesClientData = {};
            this.etreesClientData = [];
            this.etreesToDisplay = [];
            this.listEtreesDropDown = [];
            this.listCrosscoDropDown = [];
            this.warningEndpointsEtreesByKeys = {'injection': {}, 'reception': {}};
            this.warningMonitoringDevicesEtreesByKeys = {'injection': {}, 'reception': {}};
            const crosscoListRef = [];
            for (const etree of this.etrees) {
              const etreeData: any = JSON.parse(etree.jsonData) as Etree;
              delete etree.jsonData;
              const clientEtree = {
                contractReference: etreeData.contractReference,
                clientReference: etreeData.clientReference,
                id: etreeData.id,
                injection: {
                  pop: null,
                  ccps: [],
                },
                receptions: [],
              };
              if (!etreeData || etreeData.status === 'deprovisioned') {
                continue;
              }
              etreeData['_color'] = this.getNextColor();
              etree['_data'] = etreeData;
              etree.crosscosList = [];
              const activeEtreeInjectionDemarcationPoint = etreeData.activeEtreeInjectionDemarcationPoint;
              if (activeEtreeInjectionDemarcationPoint && activeEtreeInjectionDemarcationPoint.activeClientConnectionPoints) {
                clientEtree.injection.pop = activeEtreeInjectionDemarcationPoint.popShortName;
                for (const ccp of activeEtreeInjectionDemarcationPoint.activeClientConnectionPoints) {
                  const ccpDetails = this.awsService.getCcpDetails(ccp, etreeData.id, 'IN');
                  const crosscoRef = '' + ccp.crossConnectId;
                  if (!crosscoListRef.includes(crosscoRef)) {
                    crosscoListRef.push(crosscoRef);
                    this.listCrosscoDropDown.push({
                      label: crosscoRef,
                      value: crosscoRef,
                    });
                  }
                  clientEtree.injection.ccps.push(ccpDetails);
                  etree.crosscosList.push(ccpDetails.crossco);
                  // warnings
                  if (!this.warningEndpointsEtreesByKeys['injection'][ccpDetails['key']]) {
                    this.warningEndpointsEtreesByKeys['injection'][ccpDetails['key']] = [];
                  }
                  this.warningEndpointsEtreesByKeys['injection'][ccpDetails['key']].push(etree.id);
                  // warnings 2
                  if (!this.warningMonitoringDevicesEtreesByKeys['injection'][ccpDetails.key3]) {
                    this.warningMonitoringDevicesEtreesByKeys['injection'][ccpDetails.key3] = [];
                  }
                  this.warningMonitoringDevicesEtreesByKeys['injection'][ccpDetails.key3].push(etree.id);
                }
                clientEtree.injection.ccps = _.orderBy(clientEtree.injection.ccps, ['injectionMethod']);
              }
              if (etreeData.etreeReceptionDemarcationPoints) {
                for (const erp of etreeData.etreeReceptionDemarcationPoints) {
                  if (erp.status === 'deprovisioned') {
                    continue;
                  }
                  const clientReception = {
                    // pop: erp.popTechnicalId,
                    pop: erp.popShortName,
                    ccps: [],
                  };
                  for (const ccp of erp.activeClientConnectionPoints) {
                    const ccpDetails = this.awsService.getCcpDetails(ccp, etreeData.id, 'OUT');
                    const crosscoRef = '' + ccp.crossConnectId;
                    if (!crosscoListRef.includes(crosscoRef)) {
                      crosscoListRef.push(crosscoRef);
                      this.listCrosscoDropDown.push({
                        label: crosscoRef,
                        value: crosscoRef,
                      });
                    }
                    clientReception.ccps.push(ccpDetails);
                    etree.crosscosList.push(ccpDetails.crossco);
                    // warnings
                    if (!this.warningEndpointsEtreesByKeys['reception'][ccpDetails['key']]) {
                      this.warningEndpointsEtreesByKeys['reception'][ccpDetails['key']] = [];
                    }
                    this.warningEndpointsEtreesByKeys['reception'][ccpDetails['key']].push(etree.id);
                    // warnings 2
                    if (!this.warningMonitoringDevicesEtreesByKeys['reception'][ccpDetails.key3]) {
                      this.warningMonitoringDevicesEtreesByKeys['reception'][ccpDetails.key3] = [];
                    }
                    this.warningMonitoringDevicesEtreesByKeys['reception'][ccpDetails.key3].push(etree.id);
                  }
                  clientReception.ccps = _.orderBy(clientReception.ccps, ['injectionMethod']);
                  clientEtree.receptions.push(clientReception);
                }
              }
              // ignore data for MAH<->MAP (MAP_NJL4) or CAR<->CAR (CAE_NJL3)  templates
              // http://127.0.0.1/__DEVlink/git/svc/bwm_services/public/refs/etree-templates   (UUID__c)
              // MAH_NJL4, MAP_NJL4, CAQ_NJL3, CAE_NJL3, MAP_HCF, CAR_NJL3
              const excludedTemplatesIds = ['04943ac4-1ef4-11e9-8ee9-525400f40f76', 'd2bcfe50-1ef3-11e9-8ee9-525400f40f76', '527f2ee5-1f25-11e9-8ee9-525400f40f76', 'ba7c147a-1f24-11e9-8ee9-525400f40f76', 'd570114b-a9e8-b584-a0e6-45fe65fceacf', 'fa808aba-bafc-4602-3baa-8ad35decedde'];
              if (etree._data.etreeTemplateUuid && excludedTemplatesIds.includes(etree._data.etreeTemplateUuid)) {
                etree._excludedEtreeFiberTemplate = true;
              }
              etree.etreeFullName = etreeData.contractReference + (etreeData.clientReference ? ' (' + etreeData.clientReference + ') ' : '') + ' - ' + etreeData.name + ' - [' + etreeData.shortname + ']';
              etree.etreeShortName = etreeData.contractReference + (etreeData.clientReference ? ' (' + etreeData.clientReference + ') ' : '') + ' - ' + etreeData.name;
              this.listEtreesDropDown.push({
                label: etree.etreeFullName,
                value: etreeData.id,
              });
              this.etreesClientData.push(clientEtree);
              const etreeToDisplay = _.defaultsDeep(etree, clientEtree);
              this.etreesToDisplay.push(etreeToDisplay);
              this.etreesByIds[etree.id] = etree;
            }
            this.etreesClientDataAsString = JSON.stringify(this.etreesClientData);
            this.etreesToDisplay = _.orderBy(this.etreesToDisplay, ['contractReference']);
            this.listEtreesDropDown = _.orderBy(this.listEtreesDropDown, ['label']);
            this.listCrosscoDropDown = _.orderBy(this.listCrosscoDropDown, ['label']);
            this.loadedEtrees = true;
          },
          error: (error: any) => {
            this.utilsService.handleErrorWebservice$(error);
          }
        }
      );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.setIntervalHandle) {
      clearInterval(this.setIntervalHandle);
    }
  }

  scrollToTopLivePortsData() {
    const targetElement = this.fieldsetLivePortData.nativeElement;
    targetElement.scrollIntoView({behavior: 'smooth'});
  }

  isDefinedVar(obj) {
    if (typeof obj === 'undefined') {
      return false;
    }
    return true;
  }

  counterDataUpdated() {
    if (this.chartValuesHistory) {
      this.chartValuesHistory.refresh();
    }
  }

  selectGraphOverlay(event, series, key, field, overlaypanel: OverlayPanel) {
    this.selectedGraphSeries = series;
    this.selectedGraphKey = key;
    this.selectedGraphField = field;
    // this.selectedGraphData = this.awsService[this.selectedGraphSeries]
    //   && this.awsService[this.selectedGraphSeries].dataHistory
    //   && this.awsService[this.selectedGraphSeries].dataHistory[this.selectedGraphKey]
    //   && this.awsService[this.selectedGraphSeries].dataHistory[this.selectedGraphKey][this.selectedGraphField];
    this.selectedGraphData = this.awsService[this.selectedGraphSeries]
      && this.awsService[this.selectedGraphSeries].dataHistory
      && this.awsService[this.selectedGraphSeries].dataHistory[this.selectedGraphKey]
      && this.awsService[this.selectedGraphSeries].dataHistory[this.selectedGraphKey][this.selectedGraphField];
    overlaypanel.toggle(event);
  }
}
